import { Text, Title } from '@/components'
import styles from './FindCarLabel.module.scss'

export const FindCarLabel = ({ isOnlyCarNumber }: { isOnlyCarNumber: boolean }) => {
  return (
    <div className={styles.container}>
      <Title className={styles.title}>
        {isOnlyCarNumber ? (
          'Укажите гос. номер авто'
        ) : (
          <>
            Укажите гос. номер авто
            <br />
            или номер талона
          </>
        )}
      </Title>
      <Text className={styles.description}>
        Для правильного расчёта стоимости и&nbsp;идентификации автомобиля
      </Text>
    </div>
  )
}
